export default __webpack_public_path__ + "static/media/intuit-qb.a9bba759.png";